
import React from 'react'

const Privacy = () => {
  return (
    <div className="w-full">
      <div className="w-7/12  h-screen">
        <div className="px-5 py-4">
          <h5 className="text-3xl font-semibold">Privacy settings</h5>
          <div className=" border-t-2 mt-4">
            <div className="mt-4">
              <h4 className="text-xl font-semibold">Types of data collected</h4>
              <p className="text-black text-base">We collect different types of data depending on how you interact with us. This includes, for example, when you're on our site, responding to our promotional materials, and using our services to help you find a job. For example, we may collect your email address and CV information when you create your account. As another example, we may collect information about your activity on our site, such as the searches you conduct and jobs you apply to. For more information on the types of data we collect, see Section 2 of our Privacy Policy.</p>
            </div>
            <div className="mt-4">
              <h4 className="text-xl font-semibold">How my data is used and disclosed</h4>
              <p className="text-black text-base">Indeed uses data to help people get jobs. How we use and disclose your data also depends on how you use our site. We go into much greater detail in Sections 4, 5 and 9 of our Privacy Policy explaining our use and disclosure of your data, but this can include to provide our services to you, to protect you when you use our site, and to measure, improve, and promote our services.</p>
            </div>
            <div className="mt-4">
              <h4 className="text-xl font-semibold">Cookies</h4>
              <p className="text-black text-base">Our Cookie Policy explains how we use cookies, web beacons and similar technologies, including some offered by third-parties, to collect data about you. For more information about our use of these technologies and your ability to opt out of them, please check out our Cookie Policy.</p>
            </div>
            <div className="mt-4">
              <h4 className="text-xl font-semibold">Accessing and deleting my data</h4>
              <p className="text-black text-base">Indeed offers all of its users rights to access and delete their data, as detailed in Section 8 of our Privacy Policy. To access or delete your data held by Indeed, just fill out this form.</p>
            </div>
            <div className="mt-4">
              <h4 className="text-xl font-semibold">Hide my CV</h4>
              <p className="text-black text-base">You can also set your Indeed CV to 'hidden' by visiting your CV privacy settings. For more information on what it means to have a 'searchable' or 'hidden' Indeed CV, please visit Section 4 our Privacy Policy.</p>
            </div>
            <div className="mt-4">
              <h4 className="text-xl font-semibold">Calls from Employers on Indeed</h4>
              <p className="text-black text-base">You are currently unsubscribed from receiving calls from Indeed and employers who use Indeed, including using automated call technology, forwarded, or recorded calls. Calls from employers on Indeed about your applications will not be forwarded to you. You will be subscribed again the next time you apply to a job through Indeed.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Privacy
